import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

type AuthUserInfo = {
  username: string;
}

export type AuthSliceState = {
  user?: AuthUserInfo;
}

const initialState:AuthSliceState = {}

const dummyAccount = {
  username: 'admin',
}

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    initAuth(state) {
      state.user = undefined;
    },
    setAuth(state, action) {
      state.user = action.payload.data;
      // state.user = dummyAccount;
    }
  },
  extraReducers: {},
})